import { usePage } from "@inertiajs/react"
import type { ReactNode } from "react"

import { TimersPanel } from "@/components/timers-panel"
import { Toaster } from "@/components/ui/sonner"
import { useFlash } from "@/hooks/use-flash"
import { TimersProvider, useTimersContext } from "@/hooks/use-timers-context"

interface PersistentLayoutProps {
  children: ReactNode
}

function TimersPanelHost() {
  const { timers, pause, resume, cancel } = useTimersContext()
  // Cooking Mode has a fixed bottom nav; lift the panel clear of it there.
  const page = usePage()
  const path = page.url.split("?")[0]
  const liftForBottomNav = path.endsWith("/cook")
  return (
    <TimersPanel
      timers={timers}
      onPause={pause}
      onResume={resume}
      onCancel={cancel}
      liftForBottomNav={liftForBottomNav}
      nativeApp={page.props.nativeApp}
    />
  )
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash()
  return (
    <TimersProvider>
      {children}
      <TimersPanelHost />
      <Toaster richColors />
    </TimersProvider>
  )
}
